import styled from 'styled-components';
import { Flex, mediaQueries, Box } from '@lce/slice';

export const Header = styled(Flex).attrs({
  as: 'header',
  px: [ 5, 8 ],
  py: [ 5 ],
  width: 1,
  margin: '0 auto',
  alignItems: 'center',
  flexDirection: 'row',
})`
  height: 84px;
  max-width: 1500px;

  ${ mediaQueries[0] } {
    height: 110px;
  }
`;

export const Body = styled(Box)`
  max-width: 1500px;
`;

export const PDFCard = styled(Box)`
  max-width: 600px;
  margin: 0 auto;
  border: 1px solid #f5f5f5;
  box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
`;

export const Table = styled.table`
  max-width: 750px;
`;

export const Underline = styled.span`
  text-decoration: underline;
`;

export const Italic = styled.span`
  font-style: italic;
`;

export const Bold = styled.span`
  font-weight: bold;
`;
